function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 26,
    viewBox: "0 0 39 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.910448,
    y: 0.910448,
    width: 37.4328,
    height: 24.1791,
    rx: 4.38806,
    fill: "#1434CB",
    style: {
      fill: "#1434CB",
      fill: "color(display-p3 0.0784 0.2039 0.7961)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.910448,
    y: 0.910448,
    width: 37.4328,
    height: 24.1791,
    rx: 4.38806,
    stroke: "#D6DCE5",
    style: {
      stroke: "#D6DCE5",
      stroke: "color(display-p3 0.8392 0.8627 0.8980)",
      strokeOpacity: 1
    },
    strokeWidth: 0.179104
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3991 9.08903L17.6614 17.2116H15.5603L17.2982 9.08903H19.3991ZM28.2394 14.3338L29.3457 11.2835L29.9822 14.3338H28.2394ZM30.5838 17.2116H32.5274L30.8314 9.08903H29.0374C28.6343 9.08903 28.2942 9.32349 28.1428 9.68495L24.9904 17.2116H27.197L27.635 15.9987H30.3308L30.5838 17.2116ZM25.0999 14.5596C25.1089 12.4157 22.1352 12.2977 22.1558 11.3401C22.162 11.0483 22.4399 10.7387 23.0468 10.6593C23.3484 10.62 24.1775 10.5899 25.1189 11.0231L25.4876 9.30061C24.9819 9.11705 24.3312 8.94043 23.5219 8.94043C21.4452 8.94043 19.9834 10.0446 19.9711 11.6257C19.958 12.7949 21.0146 13.4474 21.8108 13.8361C22.6293 14.2343 22.9044 14.4894 22.9008 14.8454C22.8954 15.3907 22.2478 15.6308 21.6437 15.6403C20.587 15.657 19.9739 15.3552 19.4852 15.1275L19.1044 16.9073C19.5952 17.1327 20.5014 17.3286 21.4416 17.3386C23.6487 17.3386 25.0927 16.2481 25.0999 14.5596ZM16.3966 9.08903L12.9922 17.2116H10.7708L9.09559 10.7292C8.99378 10.33 8.90535 10.184 8.59607 10.0156C8.09141 9.74177 7.25717 9.48442 6.52319 9.32503L6.57332 9.08903H10.1486C10.6042 9.08903 11.0142 9.39239 11.1176 9.9171L12.0025 14.6177L14.189 9.08903H16.3966Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.f5f25eee887681f71de3c497b81abbd7.svg";
export { ForwardRef as ReactComponent };